// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-avatar-align {
  display: flex;
  justify-content: center;
}

.profile-picture {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  margin: 0 auto;
  display: block;
}

.user-name {
  text-align: center;
  font-family: var(--font);
  font-weight: 600;
  font-size: 30px;
}

.last-checkins-title {
  background: var(--bg-color);
  height: 35px;
  width: 100%;
  font-size: 14px;
  font-family: var(--font);
  font-weight: 600;
  color: #9596BC;
  margin: 5px 0;
  padding: 8px 13px;
}

.last-checkins {
  margin-bottom: 66px;
}

.btn-box {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 10px 0 15px;
  border-top: 1px solid #ECEAF3;
  background-color: #ffffff;
}

.btn-default {
  border-radius: 2px;
  width: 60%;
  min-width: 216px;
  height: 40px;
}
.btn-default span {
  text-transform: none;
  font-family: var(--font);
  font-weight: 700;
  font-size: 16px;
  margin-left: 8px;
  color: #fff;
}

.infos-box {
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  background: var(--bg-color);
  padding: 31px 0 13px;
}

ion-avatar {
  width: 140px;
  height: 140px;
  background: var(--bg-color);
  margin: auto;
  border: 4px solid #fff;
  display: flex;
  box-shadow: 0px 20px 54px rgba(32, 17, 87, 0.243198);
}
ion-avatar .cus-picture {
  width: 75px;
  height: 75px;
  margin: auto;
  border-radius: 0;
  opacity: 0.6;
}

.check-in ion-label {
  margin-left: 10px;
  font-family: var(--font);
  font-weight: 600;
  font-size: 1.3rem;
}
.check-in ion-thumbnail {
  --size: 10%;
  --border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/self-checkin/self-checkin.page.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAEJ;;AACA;EACI,2BAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,cAAA;EACA,aAAA;EACA,iBAAA;AAGJ;;AAAA;EAEI,mBAAA;AAEJ;;AACA;EACI,eAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,oBAAA;EACA,6BAAA;EACA,yBAAA;AAEJ;;AACA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AAEJ;AAAI;EACI,oBAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,gBAAA;EACA,WAAA;AAGR;;AAAA;EACI,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,2BAAA;EACA,oBAAA;AAGJ;;AADA;EACI,YAAA;EACA,aAAA;EACA,2BAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,oDAAA;AAIJ;AAHI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAKR;;AAKI;EACI,iBAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,iBAAA;AADR;AAGI;EACI,WAAA;EACA,oBAAA;AADR","sourcesContent":[".no-avatar-align {\n    display: flex;\n    justify-content: center;\n}\n\n.profile-picture {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    object-fit: cover;\n    object-position: center;\n    margin: 0 auto;\n    display: block;\n}\n\n.user-name {\n    text-align: center;\n    font-family: var(--font); font-weight: 600;;\n    font-size: 30px;\n}\n\n.last-checkins-title {\n    background: var(--bg-color);\n    height: 35px;\n    width: 100%;\n    font-size: 14px;\n    font-family: var(--font); font-weight: 600;;\n    color: #9596BC;\n    margin: 5px 0;\n    padding: 8px 13px;\n}\n\n.last-checkins{\n    // padding-bottom: 66px;\n    margin-bottom: 66px;\n}\n\n.btn-box {\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    padding: 10px 0 15px;\n    border-top: 1px solid #ECEAF3;\n    background-color: #ffffff;\n}\n\n.btn-default {\n    border-radius: 2px;\n    width: 60%;\n    min-width: 216px;\n    height: 40px;\n\n    span {\n        text-transform: none;\n        font-family: var(--font); font-weight: 700;;\n        font-size: 16px;\n        margin-left: 8px;\n        color: #fff;\n    }\n}\n.infos-box{\n    width: 100%;\n    height: fit-content;\n    background: var(--bg-color);\n    padding: 31px 0 13px;\n}\nion-avatar{\n    width: 140px;\n    height: 140px;\n    background: var(--bg-color);\n    margin: auto;\n    border: 4px solid #fff;\n    display: flex;\n    box-shadow: 0px 20px 54px rgba(32, 17, 87, 0.243198);\n    .cus-picture {\n        width: 75px;\n        height: 75px;\n        margin: auto;\n        border-radius: 0;\n        opacity: 0.6;\n    }\n}\n// .background{\n//     min-height: 0vh !important;\n//     position: relative;\n//     height: 100%;\n// }\n\n.check-in {\n    ion-label {\n        margin-left: 10px;\n        font-family: var(--font); font-weight: 600;;\n        font-size: 1.3rem;\n    }\n    ion-thumbnail {\n        --size: 10%;\n        --border-radius: 2px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
